<template>
  <scout-form
    :is-modified="value !== 1"
    label="行動ターゲティング"
  >
    <div class="boss-targeting-selector">
      <div class="pega-slider padding-bottom-1 padding-top-1">
        <vue-slider
          v-model="label"
          direction="btt"
          :adsorb="true"
          :data="options.map(option => option.label).reverse()"
          :marks="true"
          tooltip="none"
          :height="150"
        />
      </div>
    </div>
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import * as definition from '@/lib/labelValueMappings'
import VueSlider from 'vue-slider-component'
import _ from 'lodash'

export default {
  components: {
    ScoutForm,
    VueSlider
  },
  props: {
    value: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      options: definition.behaviors,
      label: _.find(definition.behaviors, behavior => _.isEqual(this.value, behavior.value)).label
    }
  },
  watch: {
    label (val) {
      this.$emit('input', _.find(definition.behaviors, behavior => _.isEqual(val, behavior.label)).value)
    }
  }
}
</script>
